export default "__VITE_ASSET__BcyKgVAb__"